<div class="background-control" [class.native-particle-bg]="currentBGType === 'nativeParticle'" [class.firefly-bg]="currentBGType === 'firefly'" [class.particles-js-bg]="currentBGType === 'particlesJs'">
    <div id="native-particle" *ngIf="currentBGType === 'nativeParticle'">
        <div class="circle-container" *ngFor="let i of nativeParticleCount">
            <div class="circle"></div>
        </div>
    </div>

    <div id="firefly" *ngIf="currentBGType === 'firefly'">
        <div class="firefly" *ngFor="let i of fireFlyCount"></div>
    </div>

    <div id="particles-js" *ngIf="currentBGType === 'particlesJs'"></div>
</div>
